import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_DELETE } from '../../constants/api';
import getRoles from './getRoles';

const deleteRole = createAsyncThunk('roles/deleteRoles',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      await authSet(METHOD_DELETE, `/roles/${id}`);
      dispatch(getRoles());
      return true;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default deleteRole;
